import { useState } from 'react';
import useReveal from '../hooks/useReveal';

const Contact = () => {
  useReveal();

  const [formState, setFormState] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: '',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    window.alert('Thank you for contacting MyFundz! We will get back to you shortly.');
    setFormState({
      name: '',
      phone: '',
      email: '',
      service: '',
      message: '',
    });
  };

  return (
    <>
      <section className="page-hero">
        <h1>Contact Us</h1>
      </section>

      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-form fade-in">
            <form id="contactForm" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    required
                    value={formState.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Your Phone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="+91-"
                    required
                    value={formState.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="yourname@gmail.com"
                  required
                  value={formState.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="service">Services</label>
                <select
                  id="service"
                  name="service"
                  required
                  value={formState.service}
                  onChange={handleChange}
                >
                  <option value="">Choose services</option>
                  <option value="mutual-funds">Mutual Fund Advisory – SIP & Lump Sum</option>
                  <option value="pms">Portfolio Management Services (PMS)</option>
                  <option value="retirement">Retirement Planning (NPS & Bonds)</option>
                  <option value="insurance">Insurance Planning</option>
                  <option value="corporate-deposits">Corporate Deposits</option>
                  <option value="loan-against-mf">Loan Against Mutual Funds</option>
                  <option value="postal-savings">Postal Savings Services</option>
                  <option value="portfolio-review">Portfolio Review & Rebalancing</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your message"
                  required
                  value={formState.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">Send message</button>
            </form>
          </div>

          <div className="need-help-card fade-in">
            <h2>"Need Help?"</h2>
            <h3>Unsure Where To Begin With Investing?</h3>
            <p>One Message Can Simplify Everything.</p>
            <p>No Pressure. No Obligation.</p>
            <p>Just Expert Guidance.</p>
            <button type="button" className="cta-button">Chat with a Financial Advisor Now</button>
          </div>
        </div>
      </section>

      <section className="directions-section">
        <div className="directions-container">
          <h2>Directions</h2>
          <div className="directions-visual fade-in">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d126246.60802773538!2d77.62095209726563!3d8.710086800000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b0411802967667d%3A0x9599d14619d0a68d!2sTirunelveli%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1709140000000!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Tirunelveli Location Map"
              className="map-iframe"
            ></iframe>

            
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
